module.exports = __webpack_public_path__ + "img/list-view.933ca530.svg";